module.exports = __webpack_public_path__ + "static/media/arrow.fd047bed.svg";